import script from './component-lib.esm5.js';
import normalizeComponent from '../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "link-wrapper",
    class: _vm.classes,
    style: _vm.styles
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-33e4ee3f_0", {
    source: ".link-wrapper[data-v-33e4ee3f]{--c-container-transition-speed:500ms;margin-bottom:var(--p-btn-margin-bottom);position:relative;transition:height var(--c-container-transition-speed)}.link-wrapper--pb[data-v-33e4ee3f]{padding-bottom:var(--p-btn-box-shadow-size)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-33e4ee3f";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var ProfileLinkWrapper = __vue_component__;
export { ProfileLinkWrapper as default };